import { Link } from 'react-router-dom';
import { useState } from 'react';

import { FiInfo, FiAlertTriangle, FiPlayCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import JobApi from 'api/job';
import AlertHelper from 'helpers/AlertHelper';
import NotificationHelper from 'helpers/NotificationHelper';

const JobInfoButton = job => {
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const [reruning, setReruning] = useState(false);

  const rerun = async () => {
    const result = await AlertHelper.confirm({
      title: `Executar novamente`,
      html: `Deseja realmente executar esse trabalho novamente?`,
    });

    if (result.value) {
      setReruning(true);
      try {
        await JobApi.rerun(job.id);
      } catch (error) {
        console.error(error);
        NotificationHelper.snack('Ocorreu um erro ao solicitar a execução do trabalho.');
      } finally {
        setReruning(false);
      }
    }
  };

  const RerunButton = () => {
    if (!job.bot.rerun_enabled) {
      return null;
    }

    return (
      <button className="btn me-3 btn-sm" disabled={reruning || job.status === 'WORKING'} onClick={rerun}>
        <FiPlayCircle size={20} /> {t(`keys.rerun`)}
      </button>
    );
  };

  const AlertsLink = () => {
    if (!parseInt(job.total_warnings)) {
      return null;
    }

    return (
      <Link to={`${url}/jobs/${job.id}/warnings`} className="btn btn-sm text-warning">
        <FiAlertTriangle size={20} /> {parseInt(job.total_warnings) || 0} {t(`keys.warnings`)}
      </Link>
    );
  };

  return (
    <div className="lh-sm">
      <RerunButton />
      <AlertsLink />

      <Link to={`${url}/jobs/${job.id}/details`} className="btn btn-sm">
        <FiInfo size={20} /> {t(`keys.details`)}
      </Link>
    </div>
  );
};

export default JobInfoButton;
